





import { defineComponent, onMounted } from '@vue/composition-api';

export default defineComponent({
	props: {
		id: {
			type: String,
			required: true,
		},
		script1: {
			type: String,
			required: true,
		},
		script2: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		onMounted(() => {
			const script1 = document.createElement('script');
			script1.src = props.script1;
			document.body.append(script1);
			const script2 = document.createElement('script');
			script2.id = 'pv_pinconnect_src';
			script2.src = props.script2;
			document.body.append(script2);
		});
		return {};
	},
});
